/**
 * Map between Universal Context (GFE) and Founder Dashboard frame contracts.
 */
import type { DateRangePreset, ComparePeriod } from './types';
import type { CompareMode, DatePreset } from '../founder-dashboard/types';

export function toDashboardDatePreset(dr: DateRangePreset): DatePreset {
  switch (dr) {
    case 'today':
      return 'today';
    case '7d':
      return '7d';
    case '30d':
    case 'yesterday':
    case 'mtd':
    case 'qtd':
    case 'ytd':
      return '30d';
    case 'custom':
      return 'custom';
    default:
      return '30d';
  }
}

export function toDashboardCompare(c: ComparePeriod): CompareMode {
  switch (c) {
    case 'none':
      return 'none';
    case 'previous_year':
      return 'prior_year';
    case 'previous_period':
    case 'custom':
    default:
      return 'prior_period';
  }
}
